/** Testi dell'area amministratore. */
export const admin = {
  comuni: {
    salva: 'Salva',
    annulla: 'Annulla',
    modifica: 'Modifica',
    cerca: 'Cerca',
    cercaAiuto: 'Nome, cognome, email o codice fiscale',
    filtroStato: 'Stato',
    tutti: 'Tutti',
    salvato: 'Modifiche salvate.',
    confermaChiusura: 'Chiudi',
    copia: 'Copia',
    copiato: 'Copiato negli appunti.',
    precedente: 'Pagina precedente',
    successiva: 'Pagina successiva',
    riepilogo: (da: number, a: number, totale: number) => `${da}–${a} di ${totale}`,
    inCorso: 'Un momento',
    caricamento: 'Caricamento in corso',
  },
  ruoli: { partecipante: 'Partecipante', relatore: 'Relatore', regia: 'Regia', admin: 'Amministratore' } as const,
  statiUtente: { in_verifica: 'Email da verificare', attivo: 'Attivo', sospeso: 'Sospeso' } as const,
  statiPercorso: { bozza: 'Bozza', pubblicato: 'Pubblicato', chiuso: 'Chiuso' } as const,
  statiWebinar: { bozza: 'Bozza', pubblicato: 'Pubblicato', in_diretta: 'In diretta', test_aperto: 'Test aperto', chiuso: 'Concluso' } as const,
  statiConferma: { invitato: 'Da confermare', confermato: 'Confermato', rinunciato: 'Rinunciato' } as const,
  modalita: { online: 'Online', sala: 'In sala' } as const,
  modalitaIngresso: { regia: 'Regia esterna', relatore: 'Dal computer del relatore' } as const,

  percorsi: {
    titolo: 'Percorsi',
    sottotitolo: 'Un percorso raccoglie i webinar di un anno e i suoi iscritti.',
    nuovo: 'Nuovo percorso',
    nessunoTitolo: 'Nessun percorso',
    nessunoTesto: 'Crea il primo percorso: poi aggiungi i webinar e importa gli iscritti.',
    colonne: { titolo: 'Titolo', anno: 'Anno', stato: 'Stato', iscritti: 'Iscritti', webinar: 'Webinar' },
    form: {
      titoloNuovo: 'Nuovo percorso',
      titoloModifica: 'Modifica percorso',
      titolo: 'Titolo',
      anno: 'Anno',
      descrizione: 'Descrizione',
      descrizioneAiuto: 'Facoltativa. Compare nella pagina di iscrizione pubblica.',
      organizzatoreEmail: 'Email dell’organizzatore',
      organizzatoreEmailAiuto: 'Riceve il report Excel alla chiusura di ogni test.',
      iscrizioneAperta: 'Iscrizione pubblica aperta',
      iscrizioneApertaAiuto: 'Chi ha il link può iscriversi da solo con il proprio codice fiscale.',
      crea: 'Crea il percorso',
      creato: 'Percorso creato.',
    },
    dettaglio: {
      pubblica: 'Pubblica',
      pubblicaTesto: 'Gli iscritti vedranno il percorso e riceveranno gli inviti ai webinar.',
      chiudi: 'Chiudi il percorso',
      chiudiTesto: 'Nessun nuovo webinar né nuove iscrizioni. I dati restano consultabili.',
      pubblicato: 'Percorso pubblicato.',
      chiuso: 'Percorso chiuso.',
      schede: { webinar: 'Webinar', iscritti: 'Iscritti', import: 'Import' },
      linkPubblico: 'Modulo pubblico di iscrizione',
      linkPubblicoAiuto: 'Condividi questo indirizzo con chi deve iscriversi da solo.',
      nuovoWebinar: 'Nuovo webinar',
      nessunWebinarTitolo: 'Nessun webinar',
      nessunWebinarTesto: 'Aggiungi il primo webinar con data, orario e relatori.',
    },
    iscritti: {
      titolo: 'Iscritti',
      aggiungi: 'Aggiungi per email',
      aggiungiTitolo: 'Aggiungi un iscritto',
      aggiungiTesto: 'La persona deve avere già un account Aulaviva. Per i nuovi usa l’import.',
      aggiungiAzione: 'Aggiungi',
      aggiunto: 'Iscritto aggiunto.',
      email: 'Email',
      nessunoTitolo: 'Nessun iscritto',
      nessunoTesto: 'Importa un file oppure aggiungi una persona per email.',
      nessunRisultato: 'Nessun iscritto corrisponde alla ricerca.',
      colonne: { nome: 'Nome', email: 'Email', codiceFiscale: 'Codice fiscale', ordine: 'Ordine', stato: 'Stato', origine: 'Origine', dal: 'Iscritto dal' },
      origini: { form: 'Modulo', import: 'Import' } as const,
      annulla: 'Annulla iscrizione',
      annullaTitolo: 'Annullare l’iscrizione?',
      annullaTesto: (nome: string) => `${nome} non riceverà più inviti ai webinar di questo percorso. L’account resta.`,
      annullaConferma: 'Sì, annulla',
      annullata: 'Iscrizione annullata.',
      avvisoCf: 'I codici fiscali sono visibili per intero solo in questa pagina. Ogni consultazione resta nel registro eventi.',
    },
    import: {
      titolo: 'Import degli iscritti',
      passi: ['Carica il file', 'Controlla l’anteprima', 'Conferma'],
      file: 'File degli iscritti',
      fileAiuto: 'CSV o Excel, fino a 5 MB. Colonne: codiceFiscale, nome, cognome, email, ordine, numeroAlbo.',
      scegli: 'Scegli un file',
      modello: 'Scarica il modello CSV',
      carica: 'Carica e controlla',
      caricamento: 'Lettura del file in corso',
      anteprimaTitolo: 'Anteprima',
      righeTotali: (n: number) => `${n} righe lette`,
      righeValide: (n: number) => `${n} valide`,
      righeErrate: (n: number) => `${n} con errori`,
      nuoviUtenti: (n: number) => `${n} nuovi account da creare`,
      utentiEsistenti: (n: number) => `${n} account già esistenti`,
      giaIscritti: (n: number) => `${n} già iscritti al percorso`,
      erroriTitolo: 'Righe con errori',
      erroriTesto: 'Le righe con errori vengono saltate. Correggi il file e ricaricalo, oppure conferma solo le righe valide.',
      colonneErrori: { riga: 'Riga', campo: 'Campo', messaggio: 'Problema' },
      esempioTitolo: 'Prime righe valide',
      esiti: { nuovo: 'Nuovo', esistente: 'Esistente', gia_iscritto: 'Già iscritto' } as const,
      riepilogo: (utenti: number, email: number) => `Verranno creati ${utenti} nuovi account e inviate ${email} email.`,
      riepilogoEsistenti: (n: number) => `${n} persone con account già attivo verranno iscritte senza nuova password.`,
      conferma: 'Conferma l’import',
      confermaInCorso: 'Import in corso',
      annullaImport: 'Annulla e ricarica',
      esitoTitolo: 'Import completato',
      esito: (e: { utentiCreati: number; iscrizioniCreate: number; emailAccodate: number; giaIscritti: number }) =>
        `${e.iscrizioniCreate} iscrizioni create, ${e.utentiCreati} nuovi account, ${e.emailAccodate} email in invio, ${e.giaIscritti} già iscritti saltati.`,
      nuovoImport: 'Nuovo import',
      vaiAgliIscritti: 'Vai agli iscritti',
      nessunaRigaValida: 'Nessuna riga valida: controlla le colonne del file.',
      fileTroppoGrande: 'Il file supera i 5 MB.',
      fileNonSupportato: 'Il file deve essere CSV o Excel (.xlsx).',
    },
  },

  webinar: {
    titolo: 'Webinar',
    sottotitolo: 'Tutti i webinar, in ordine di data.',
    nuovo: 'Nuovo webinar',
    nessunoTitolo: 'Nessun webinar',
    nessunoTesto: 'Crea un percorso e poi il suo primo webinar.',
    colonne: { quando: 'Quando', titolo: 'Titolo', percorso: 'Percorso', stato: 'Stato', confermati: 'Confermati', ingresso: 'Ingresso' },
    confermati: (online: number, sala: number) => `${online} online · ${sala} in sala`,
    form: {
      titoloNuovo: 'Nuovo webinar',
      titoloModifica: 'Modifica webinar',
      percorso: 'Percorso',
      titolo: 'Titolo',
      descrizione: 'Descrizione',
      inizio: 'Inizio',
      fine: 'Fine',
      orariAiuto: 'Orario di Roma.',
      durata: 'Durata ufficiale (minuti)',
      durataAiuto: 'Base per il calcolo della presenza. Precompilata dalla differenza tra fine e inizio.',
      relatori: 'Relatori',
      relatoriAiuto: 'Solo gli utenti con ruolo Relatore. Cambia il ruolo dalla pagina Utenti.',
      nessunRelatore: 'Nessun utente con ruolo Relatore.',
      modalita: 'Modalità di ingresso del flusso',
      modalitaRegia: 'Regia esterna',
      modalitaRegiaTesto: 'La regia della sala invia il flusso in SRT (RTMP di riserva).',
      modalitaRelatore: 'Dal computer del relatore',
      modalitaRelatoreTesto: 'Il relatore trasmette dal browser, senza regia: serve un microfono esterno e una prova il giorno prima.',
      soglie: 'Soglie',
      soglia: 'Soglia di presenza (%)',
      sogliaAiuto: 'Il test si apre con almeno questa percentuale. Default 75.',
      testDurata: 'Durata del test (minuti)',
      testFinestra: 'Finestra del test dopo la fine (ore)',
      crea: 'Crea il webinar',
      creato: 'Webinar creato. Ora pubblicalo quando è pronto.',
    },
    dettaglio: {
      schede: { riepilogo: 'Riepilogo', conferme: 'Conferme', checklist: 'Lista di controllo' },
      quando: 'Quando',
      durata: (min: number) => `${min} minuti ufficiali`,
      relatori: 'Relatori',
      nessunRelatore: 'Nessun relatore assegnato.',
      ingresso: 'Ingresso del flusso',
      conteggi: 'Partecipazione',
      invitati: 'Da confermare',
      online: 'Online',
      sala: 'In sala',
      rinunciati: 'Rinunce',
      pubblica: 'Pubblica',
      pubblicaTitolo: 'Pubblicare il webinar?',
      pubblicaTesto: 'Comparirà nel percorso degli iscritti. Gli inviti partono da soli 7 giorni prima, oppure ora con il bottone dedicato.',
      pubblicato: 'Webinar pubblicato.',
      inviaInviti: 'Invia gli inviti ora',
      invitiTitolo: 'Inviare gli inviti adesso?',
      invitiTesto: (n: number) => `Partirà un’email a ${n} iscritti attivi con i link per confermare online, in sala o rinunciare.`,
      invitiInviati: (data: string) => `Inviti inviati il ${data}.`,
      invitiAutomatici: 'Gli inviti partono da soli 7 giorni prima dell’inizio.',
      inviaPromemoria: 'Invia il promemoria ora',
      promemoriaTitolo: 'Inviare il promemoria adesso?',
      promemoriaTesto: 'Partirà un’email a chi non ha ancora risposto all’invito.',
      promemoriaInviato: (data: string) => `Promemoria inviato il ${data}.`,
      promemoriaAutomatico: 'Il promemoria parte da solo il giorno prima.',
      inviato: 'Email in invio.',
      conferma: 'Conferma',
      conferme: {
        colonne: { nome: 'Nome', email: 'Email', stato: 'Stato', modalita: 'Modalità', quando: 'Risposta' },
        nessuna: 'Nessuna conferma ancora: gli inviti non sono partiti o nessuno ha risposto.',
        nessunRisultato: 'Nessuna conferma corrisponde alla ricerca.',
      },
      checklist: {
        titolo: 'Lista di controllo',
        sottotitolo: 'Le voci automatiche si aggiornano da sole; le altre le spunti tu.',
        momenti: { '-7g': '7 giorni prima', '-1g': 'Il giorno prima', '-90min': '90 minuti prima', '-60min': '60 minuti prima', '-30min': '30 minuti prima', diretta: 'Durante la diretta', fine: 'Fine della diretta', '+2h': '2 ore dopo' } as const,
        stati: { da_fare: 'Da fare', fatta: 'Fatta', automatica_ok: 'Fatta automaticamente', automatica_errore: 'Errore automatico', non_applicabile: 'Non applicabile' } as const,
        fattaDa: (chi: string, quando: string) => `${chi}, ${quando}`,
        note: 'Note',
        nonApplicabile: 'Segna come non applicabile',
        riapri: 'Riapri',
        nessuna: 'La lista di controllo viene generata alla creazione del webinar.',
      },
    },
  },

  utenti: {
    titolo: 'Utenti',
    sottotitolo: 'Tutti gli account. Da qui assegni i ruoli di relatore, regia e amministratore.',
    filtroRuolo: 'Ruolo',
    nessunoTitolo: 'Nessun utente',
    nessunoTesto: 'Gli account compaiono qui dopo la registrazione o l’import.',
    nessunRisultato: 'Nessun utente corrisponde alla ricerca.',
    colonne: { nome: 'Nome', email: 'Email', ruolo: 'Ruolo', stato: 'Stato', ultimoAccesso: 'Ultimo accesso', creato: 'Creato' },
    mai: 'Mai',
    cambiaRuolo: 'Cambia ruolo',
    cambiaRuoloTitolo: (nome: string) => `Ruolo di ${nome}`,
    nuovoRuolo: 'Nuovo ruolo',
    avvisoRelatore: 'I relatori vedono solo conteggi, mai i dati dei partecipanti.',
    avvisoAdmin: 'Gli amministratori vedono i codici fiscali per intero e moderano le domande.',
    conferma: 'Cambia ruolo',
    cambiato: 'Ruolo aggiornato.',
  },
};
